var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6137 20.0658C2.34081 15.6946 2.56818 10.8873 5.55332 7.60599C8.62703 4.22731 14.4091 2.70407 21.5579 4.70574C21.8304 4.78204 22.0434 4.99499 22.1197 5.26748C24.1212 12.4164 22.598 18.1984 19.2193 21.272C15.938 24.2572 11.1307 24.4845 6.75947 21.2117L4.66036 23.3108C4.34396 23.6272 3.83099 23.6272 3.51458 23.3108C3.19819 22.9944 3.19819 22.4814 3.51458 22.165L5.6137 20.0658ZM13.6664 9.45068C13.9937 9.04149 14.6422 9.27823 14.6422 9.80694V12.169H16.2317C16.6957 12.169 16.9513 12.7205 16.6574 13.0879L13.4177 17.1376C13.0904 17.5468 12.4419 17.3101 12.4419 16.7813V14.4193H10.8525C10.3884 14.4193 10.1328 13.8678 10.4267 13.5005L13.6664 9.45068Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPower);
export default __webpack_public_path__ + "static/media/green-power.26664da8969c09f72c690323ad4318ca.svg";
export { ForwardRef as ReactComponent };